import { ajax } from "lib/observable";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { UTILITIES } from "constants/action-types";
import siteConfig from "site-config";
import { stringify } from "querystring";

export const fetchActiveStatusesEpic = (action$, store) =>
    action$.ofType(UTILITIES.ACTIVE_STATUSES.FETCH.START).switchMap(({ payload: { id, type, filters } }) =>
        ajax(
            `${siteConfig.api}/nuorder/management/active-status/${type}/${id}${Object.keys(filters).length ? "?" + stringify(filters) : ""}`
        )
            .flatMap(({ response }) => [
                {
                    payload: response,
                    type: UTILITIES.ACTIVE_STATUSES.FETCH.SUCCESS,
                },
            ])
            .catch((error) =>
                Observable.merge(
                    Observable.of({
                        error: true,
                        payload: error,
                        type: UTILITIES.ACTIVE_STATUSES.FETCH.SUCCESS,
                    })
                )
            )
    );

export const fetchMoreActiveStatusesEpic = (action$, store) =>
    action$.ofType(UTILITIES.ACTIVE_STATUSES.PAGINATED.START).switchMap(({ payload: { id, type, filters } }) =>
        ajax(
            `${siteConfig.api}/nuorder/management/active-status/${type}/${id}${Object.keys(filters).length ? "?" + stringify(filters) : ""}`
        )
            .flatMap(({ response }) => [
                {
                    payload: response,
                    type: UTILITIES.ACTIVE_STATUSES.PAGINATED.SUCCESS,
                },
            ])
            .catch((error) =>
                Observable.merge(
                    Observable.of({
                        error: true,
                        payload: error,
                        type: UTILITIES.ACTIVE_STATUSES.PAGINATED.SUCCESS,
                    })
                )
            )
    );
